import { LayoutRectangle } from 'react-native';

import {
    SharedValue,
    useDerivedValue,
    useSharedValue,
} from 'react-native-reanimated';

import { isInbound } from './inbound';

export const useIsInboundAnimated = (
    rect: LayoutRectangle,
    xStartOffset?: SharedValue<number>,
    xEndOffset?: SharedValue<number>,
    yStartOffset?: SharedValue<number>,
    yEndOffset?: SharedValue<number>,
) => {
    const inbound = useSharedValue(false);

    useDerivedValue(() => {
        const _inbound = isInbound(
            rect,
            xStartOffset,
            xEndOffset,
            yStartOffset,
            yEndOffset,
        );
        inbound.value = _inbound;
    }, [rect]);

    return inbound;
};
